<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'mapping-group-banner'"
    @hidden="$emit('onCloseModal', mappingBannerList)"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="mapping-tab-banner">
        <div
          class="mapping-banner-head-label"
          :class="tabActive == 'bannerList' ? 'active' : ''"
          @click="onTabChange('bannerList')"
        >
          Banner List
        </div>
        <div
          class="mapping-banner-head-label"
          :class="tabActive == 'setBanner' ? 'active' : ''"
          @click="onTabChange('setBanner')"
        >
          Banner Set
        </div>
      </div>
    </template>
    <b-row
      v-if="tabActive == 'bannerList'"
      key="bannerList"
      class="modal-body-container mb-1"
    >
      <b-col
        cols="12"
        class="p-2"
      >
        <search
          :on-search-input="onSearchBanner"
          class="mapping-search"
        />
      </b-col>
      <b-col cols="12">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields.bannerList"
              :items="mappingBannerTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="banner-mapping-table-modal"
            >
              <template #cell(banner_image_image_url)="data">
                <div
                  v-if="data.item.banner_image_image_url"
                  class="col-img"
                >
                  <img
                    class="h-100"
                    :src="data.item.banner_image_image_url"
                    alt=""
                    draggable="false"
                  >
                </div>
                <div v-else>
                  -
                </div>
              </template>
              <template #cell(call_to_action)="data">
                <span>{{ resolveCallToAction(data.item.call_to_action) }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-if="data.item.status"
                    icon="CircleIcon"
                    class="active-icon mr-2"
                  />

                  <span>{{ resolveBannerStatusLabel(data.item.status) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CircleIcon"
                    class="inActive-icon mr-2"
                  />
                  <span class="inActive-label">{{
                    resolveBannerStatusLabel(data.item.status)
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <add-banner-button
                  btn-label="Add Banner"
                  :disabled="data.item.mapping"
                  @click.native="addMappingBanner(data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <b-row
      v-else
      key="setBanner"
      class="modal-body-container mb-1"
    >
      <b-col
        cols="12"
        class="p-2"
      >
        <search
          class="mapping-search"
          :on-search-input="onSearchBanner"
        />
      </b-col>
      <b-col cols="12">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields.setBanner"
              :items="mappingSetBannerTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="set-banner-mapping-table-modal"
            >
              <template #cell(valid_from)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_from)
                }}</span>
              </template>
              <template #cell(valid_through)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_through)
                }}</span>
              </template>
              <template #cell(updatetime)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.updatetime)
                }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-if="data.item.status"
                    icon="CircleIcon"
                    class="active-icon mr-2"
                  />

                  <span>{{ resolveBannerStatusLabel(data.item.status) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CircleIcon"
                    class="inActive-icon mr-2"
                  />
                  <span class="inActive-label">{{
                    resolveBannerStatusLabel(data.item.status)
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <add-banner-button
                  btn-label="Add Banner Set"
                  :disabled="data.item.mapping"
                  @click.native="addMappingSetBanner(data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
  </base-modal>
</template>
<script>
import BaseModal from '@core/components/base-modal/BaseModal.vue'
import {
  BRow, BCol, BButton, BTable, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Search from '@/views/components/search/Search.vue'
import AddBannerButton from '@/views/components/button/AddBannerButton.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useMappingBannerModal from '../hooks/useMappingBannerModal'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    vSelect,
    BaseModal,
    Search,
    BTable,
    AddBannerButton,
    BSpinner,
    CardNoItem,
    PaginationWithReorder,
  },
  props: {
    isSet: Boolean,
    mappingList: Array,
  },
  setup(props) {
    const {
      tabActive,
      fields,
      mappingBannerTable,
      mappingSetBannerTable,
      pagination,
      loading,
      mappingBannerList,
      resolveBannerStatusLabel,
      resolveCallToAction,
      resolveDateWithSeperator,
      addMappingBanner,
      addMappingSetBanner,
      onSearchBanner,
      onPageChange,
      onTabChange,
      fetchBannerMappingList,
      onModalOpen,
    } = useMappingBannerModal(props)

    const resolveCssVariables = () => {
      const cssVariables = this.$store.getters['appConfig/cssVariables']
      return cssVariables
    }

    return {
      tabActive,
      fields,
      mappingBannerTable,
      mappingSetBannerTable,
      pagination,
      loading,
      mappingBannerList,
      resolveBannerStatusLabel,
      resolveCallToAction,
      resolveCssVariables,
      resolveDateWithSeperator,
      addMappingBanner,
      addMappingSetBanner,
      onSearchBanner,
      onPageChange,
      onTabChange,
      fetchBannerMappingList,
      onModalOpen,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/banner/mapping-group-banner-modal.css';
@import '~@/assets/css/override-styles/status.css';
</style>
